import { IControls } from '../ABSForm';

export default class ABSExpertListDataHelper {
  static getControls({ key, label, defaultValue }: { key: string; label: string, defaultValue?: string }) {
    const controls: IControls[] = [
      {
        type: 'search',
        label: '收件人',
        id: 'user_ids',
        required: true,
        placeholder: '收件人',
        style: { width: 400 },
        multipleMaxNum: 1,
        defaultValue: [{ key, label }],
        // labelInValue: true,
        isForm: true
      },
      {
        type: 'input',
        label: '站内信主题',
        id: 'title',
        required: true,
        style: { width: 668 },
        defaultValue: defaultValue,
      },
      {
        type: 'textarea',
        label: '站内信内容',
        id: 'content',
        className: 'internal-message-textarea-write',
        style: { width: 668, height: 366 },
        bottomTextClassName: 'bottom-hint-class-name'
      }
    ];
    return controls;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSExpertList/ABSExpertListDataHelper.tsx